/**
 * Utility functions for text processing
 */

/**
 * Converts plain text URLs in a string to markdown links while preserving markdown formatting
 * @param {string} text - The text containing URLs to convert
 * @returns {string} - Text with URLs converted to markdown links
 */
export const convertUrlsToMarkdownLinks = (text) => {
  if (!text) return '';
  
  // Regular expression to match URLs
  // This pattern matches most common URL formats including http, https, www
  const urlRegex = /(https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&//=]*))/g;
  
  // Process the text line by line to preserve markdown formatting
  const lines = text.split('\n');
  const processedLines = lines.map(line => {
    // Only convert URLs in non-markdown link lines
    // Check if the line already contains a markdown link
    if (!line.match(/\[.*\]\(.*\)/)) {
      return line.replace(urlRegex, (url) => {
        return `[${url}](${url})`;
      });
    }
    return line;
  });
  
  // Join the lines back together
  return processedLines.join('\n');
};
